var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBtnBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40495 0.345101C8.5454 0.485726 8.62429 0.676352 8.62429 0.875102C8.62429 1.07385 8.5454 1.26448 8.40495 1.4051L3.43495 6.3751L17.875 6.3751C18.0739 6.3751 18.2646 6.45412 18.4053 6.59477C18.5459 6.73542 18.625 6.92619 18.625 7.1251C18.625 7.32401 18.5459 7.51478 18.4053 7.65543C18.2646 7.79608 18.0739 7.8751 17.875 7.8751L3.43495 7.8751L8.40495 12.8451C8.50367 12.9368 8.57585 13.0534 8.61386 13.1826C8.65187 13.3119 8.65432 13.449 8.62095 13.5795C8.58758 13.71 8.51962 13.8291 8.42423 13.9243C8.32884 14.0194 8.20956 14.0871 8.07895 14.1201C7.94857 14.1535 7.8116 14.1512 7.68244 14.1134C7.55328 14.0755 7.43669 14.0036 7.34495 13.9051L1.09495 7.6551C0.9545 7.51448 0.87561 7.32385 0.87561 7.1251C0.87561 6.92635 0.9545 6.73573 1.09495 6.5951L7.34495 0.345101C7.48558 0.204651 7.6762 0.125762 7.87495 0.125762C8.0737 0.125762 8.26432 0.204651 8.40495 0.345101Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnBlack);
export default __webpack_public_path__ + "static/media/backBtnBlack.04035d2542b1d71f568f1ad6775a779e.svg";
export { ForwardRef as ReactComponent };